import { useMemo } from 'react';
import { core_v1_Rule } from '@antimatterhq/asl-api-ts-v1';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import Spacer from '@antimatterhq/ui/components/spacer';

interface NotableOutputReviewProps {
  rule: core_v1_Rule;
}

export function NotableOutputReview({ rule }: NotableOutputReviewProps) {
  const output = rule.spec.output;
  const contextValues = useMemo(
    () => Object.entries(output?.context || {}),
    [output.context],
  );

  return (
    <div>
      <Fieldset.Field>
        <Fieldset.Label>Summary:</Fieldset.Label>
        <Fieldset.Value>{output?.summary}</Fieldset.Value>
      </Fieldset.Field>

      <Spacer size="lg" />

      <Fieldset.Field>
        <Fieldset.Label>Context</Fieldset.Label>
      </Fieldset.Field>
      <Fieldset.List>
        {contextValues.length > 0 ? (
          contextValues.map(([key, value]) => (
            <Fieldset.Field key={key}>
              <Fieldset.Label>{key}:</Fieldset.Label>
              <Fieldset.Value>{value}</Fieldset.Value>
            </Fieldset.Field>
          ))
        ) : (
          <Fieldset.Value>
            <span className="italic">[none]</span>
          </Fieldset.Value>
        )}
      </Fieldset.List>
    </div>
  );
}
